import { useLayoutEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { sendUserEPIK } from 'root-redux/actions/user'
import { selectPinterestTagId } from 'root-redux/selects/common'
import { selectUUID } from 'root-redux/selects/user'

import { getSha256Hash } from 'helpers/getSha256Hash'

import { PINTEREST_CLICK_ID_QUERY_PARAM } from 'root-constants'

import { useCookieConsentAnswer } from './useCookieConsentAnswer'

export const useInitPinterestTag = (): void => {
  const dispatch = useDispatch()
  const uuid = useSelector(selectUUID)
  const pinterestTagId = useSelector(selectPinterestTagId)
  const { canUseAdvertising } = useCookieConsentAnswer()

  useLayoutEffect(() => {
    if (!pinterestTagId || !uuid) return

    const searchParams = new URLSearchParams(document.location.search)
    const epik = searchParams.get(PINTEREST_CLICK_ID_QUERY_PARAM)

    if (epik) dispatch(sendUserEPIK(epik))

    if (!canUseAdvertising) {
      return
    }

    if (window.pintrk) return

    const script = document.createElement('script')
    script.type = 'text/javascript'
    script.text = `
      !function(e) {
        if(!window.pintrk) {
          window.pintrk=function() {
            window.pintrk.queue.push(Array.prototype.slice.call(arguments))
          };
          var n=window.pintrk;n.queue=[],n.version="3.0";
          var t=document.createElement("script");t.async=!0,t.src=e;
          var r=document.getElementsByTagName("script")[0];
              r.parentNode.insertBefore(t,r)
        }
      }
      ("https://s.pinimg.com/ct/core.js");
      pintrk('load', ${pinterestTagId}, {external_id: '${getSha256Hash(uuid)}'});
      pintrk('page');
      `
    document.head.appendChild(script)
  }, [dispatch, pinterestTagId, canUseAdvertising, uuid])
}
